import store from '@state/store'
import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";

export default [

  {
    path: '/:merchantAlias/login/lineLinkToken/:lineLinkToken',
    name: 'line login',
    component: () => lazyLoadView(import('@views/login/index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (store.getters['auth/loggedIn']) {
            // next({ name: 'member-order', query: { language: routeTo.query.language || routeFrom.query.language }})
            store.dispatch('auth/lineLogIn', {
              lineLinkToken: routeTo.params.lineLinkToken,
              merchantAlias: routeTo.params.merchantAlias,
            })
          }else {
            await store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            });

            next()
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Login' } }));
        }
      },
      showLoginButton: false,
      showShareButton: false,
    },
  },
  {
    path: '/:merchantAlias/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login/index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (store.getters['auth/loggedIn']) {
            next({
              name: 'member-order',
              params: {
                merchantAlias: routeTo.params.merchantAlias
              },
              query: {
                language: routeTo.query.language || routeFrom.query.language
              }
            })

          }else {
            await store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            });

            next()
          }

        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Login' } }));
        }
      },
      showLoginButton: false,
      showShareButton: false,
    },
  },
]
